import { StaticDataFetcherItem } from '@hh.ru/magritte-common-data-provider';

export const getChecked = <DataType extends StaticDataFetcherItem>(
    currentValue: DataType,
    selectedValues: DataType[] | DataType
): boolean =>
    Array.isArray(selectedValues)
        ? !!selectedValues.find((item) => item.value === currentValue.value)
        : selectedValues.value === currentValue.value;
